<header class="w3-container" style="padding-top:22px">
  
    <table style="width: 100%"><tr>
    <td style="width:100%"><h5><b><i class="fa fa-book"></i> {{title}}</b></h5></td>
    <td><button [class.w3-theme-d4]="lang == 'C'" (click)="setLang('C')" mat-button class="w3-theme-l3" >中</button></td>
	<td><button [class.w3-theme-d4]="lang == 'E'" (click)="setLang('E')" mat-button class="w3-theme-l3" >EN</button></td>	
    </tr>
    </table>
      
    </header> 
  
    <div class="w3-panel">
      <div class="w3-row-padding" style="margin:0 -16px">
      <div class="w3-container" >
      <table  >
        <tr>
        <td>Sort By:</td>
        <td><button [class.w3-theme-d4]="sort == 'year'" (click)="getQuestion('year')" mat-button style="width:100%" class="w3-half w3-theme-l3 "><i class="fa fa-sort-numeric-asc"></i> Question Number</button></td>
        <td><button [class.w3-theme-d4]="sort == 'rate'" (click)="getQuestion('rate')" mat-button style="width:100%" class="w3-button w3-half w3-theme-l3 "><i class="fa fa-sort-numeric-asc"></i> Correct Rate</button></td>
        </tr>
      </table>
      </div>
      
     <hr>
     <div class="row">
     <div class="col-sm-6">
        <mat-card><h5>My Result</h5>
          <table class="table">

            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">This submission (2/11/2019)</th>
                <th scope="col">Last submission (1/11/2019)</th>
                
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Score</th>
                <td>15/20</td>
                <td>10/20</td>
              </tr>
              
            </tbody>
          </table>  </mat-card>
          <br>
          <mat-card><h5>The average correct percentage for this topic among students</h5>
            <br>
            <table  style="width: 100%">
                <tr>
                <td>Scope:</td>
                <td ><button mat-button id="same_school_but" onClick="tosameschool()"  style="width:100%" class="w3-button w3-half w3-theme-d2"><i class="fa fa-users"></i> Same School</button></td>
                <td ><button mat-button id="all_school_but" onClick="toallschool()" style="width:100%" class="w3-button w3-half w3-theme-l5"><i class="fa fa-users"></i> All schools</button></td>
                </tr>
            </table>
            <table class="table">
  
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First Trial</th>
                  <th scope="col">All Trial</th>
                  
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">2020</th>
                  <td>15/20</td>
                  <td>10/20</td>
                </tr>
                <tr>
                    <th scope="row">2021</th>
                    <td>15/20</td>
                    <td>10/20</td>
                  </tr>
                  <tr>
                      <th scope="row">2022</th>
                      <td>15/20</td>
                      <td>10/20</td>
                    </tr>
                    <tr>
                        <th scope="row">All Years</th>
                        <td>15/20</td>
                        <td>10/20</td>
                      </tr>
                
              </tbody>
            </table>  </mat-card>
            <br>
      </div>
      <div class="col-sm-6">
          <mat-card>   
        <div id="chartContainer" style="height: 370px; width: 100%;"></div>
        <table  style="width: 100%">
            <tr>
            <td>Scope:</td>
            <td ><button mat-button id="same_school_but" onClick="tosameschool()"  style="width:100%" class="w3-button w3-half w3-theme-d2"><i class="fa fa-users"></i> Same School</button></td>
            <td ><button mat-button id="all_school_but" onClick="toallschool()" style="width:100%" class="w3-button w3-half w3-theme-l5"><i class="fa fa-users"></i> All schools</button></td>
            </tr>
            <tr>
            <td>Trial:</td>
            <td ><button mat-button id="same_school_but" onClick="tosameschool()"  style="width:100%" class="w3-button w3-half w3-theme-d2"><i class="fa fa-users"></i> 1st Trial</button></td>
            <td ><button mat-button id="all_school_but" onClick="toallschool()" style="width:100%" class="w3-button w3-half w3-theme-l5"><i class="fa fa-users"></i> All Trial</button></td>
            </tr>
            <tr>
            <td>Cohort:</td>
            <td ><button mat-button id="same_school_but" onClick="tosameschool()"  style="width:100%" class="w3-button w3-half w3-theme-d2"><i class="fa fa-users"></i> 2020</button></td>
            <td ><button mat-button id="all_school_but" onClick="toallschool()" style="width:100%" class="w3-button w3-half w3-theme-l5"><i class="fa fa-users"></i> 2021</button></td>
            </tr>
            </table>
        </mat-card>
      </div>
     </div>
     <hr>
    
          <div class="row">
            <div *ngFor="let question of questions | async; index as question_no" class="col-sm-3">
          <mat-card>      
              <h5>Question {{question_no +1}}<span style="font-size: 12px"> - {{question.paper_name}}   Q{{question.question_no}} , correct rate: {{question.rate | percent}}</span></h5>      
            <div style="max-width: 100%;" class=" w3-container w3-middle">
                <p><img style="max-width: 100%;max-height: 800px;"  src="../images/question/{{question.folder_name}}/{{question.folder_name}}_Q{{question.question_no}}_{{lang}}.png"></p>
            </div>
            <table style="width: 100%">
              <tr>
                <td>A</td>
                <td style="width: 90%">
                    <div class="progress" style="height: 7px;">
                        <div class="progress-bar w3-theme-d5" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                </td>
              </tr>
              <tr>
                  <td>B</td>
                  <td style="width: 90%">
                      <div class="progress" style="height: 7px;">
                          <div class="progress-bar w3-theme-d5" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                  </td>
                </tr>
                <tr>
                    <td>C</td>
                    <td style="width: 90%">
                        <div class="progress" style="height: 7px;">
                            <div class="progress-bar w3-theme-d5" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                    </td>
                  </tr>
                  <tr>
                      <td>D</td>
                      <td style="width: 90%">
                          <div class="progress" style="height: 7px;">
                              <div class="progress-bar w3-theme-d5" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                      </td>
                    </tr>
            </table>
            
             
              <br>
              <table style="width: 100%"><tr>
                  <td><button mat-button class="w3-button w3-theme-l3 w3-block "><i class="fa fa-youtube-play"></i></button></td>
              <td style="width: 100%"><button mat-button class="w3-button w3-theme-l3 w3-block "><i class="fa fa-file-picture-o"></i> Answer</button></td>
              
              <td><button mat-button  class="w3-button w3-theme-l3 w3-block "><i class="fa fa-comment"></i></button></td>
              </tr>
              </table>
          </mat-card>
          <br>
  
                
            </div>
           
          </div>
    
        
          </div></div>